import { Injectable } from '@angular/core'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'

@Injectable({
  providedIn: 'root'
})
export class FormIngresoService {
  constructor (private readonly fb: FormBuilder) {}

  getIngresoForm () {
    return this.fb.group({
      hasAccountingDocuments: new FormControl(true, { nonNullable: true }),
      razonSocial: new FormControl('', { nonNullable: true }),
      ruc: new FormControl('', { nonNullable: true }),
      numFactura: new FormControl('', { nonNullable: true }),
      fechaFactura: new FormControl('', { nonNullable: true }),
      insumoAlmacen: new FormGroup({
        cantidad: new FormControl('', { nonNullable: true }),
        costo: new FormControl('', { nonNullable: true }),
        unidadMedida: new FormControl('', { nonNullable: true })
      }),
      fileNumber: new FormControl('', { nonNullable: true }),
      idItinerary: new FormControl('', { nonNullable: true }),
      numRecibo: new FormControl('', { nonNullable: true }),
      fechaRecibo: new FormControl('', { nonNullable: true }),
      acquisitionDate: new FormControl('', { nonNullable: true }),
      observation: new FormControl('', { nonNullable: true })
    })
  }

  getInsumoForm () {
    return this.fb.group({
      id: new FormControl('', { nonNullable: true }),
      nombreInsumo: new FormControl('', { nonNullable: true }),
      cantidad: new FormControl('', { nonNullable: true }),
      unidadMedida: new FormControl('', { nonNullable: true }),
      categoria: new FormControl('', { nonNullable: true }),
      peso: new FormControl('', { nonNullable: true })
    })
  }

  getIngresoEquipoForm () {
    return this.fb.group({
      factura: new FormControl('', { nonNullable: true }),
      equipoAlmacen: new FormGroup({
        marca: new FormControl('', { nonNullable: true }),
        modelo: new FormControl('', { nonNullable: true }),
        talla: new FormControl('', { nonNullable: true }),
        valoracion: new FormControl('', { nonNullable: true }),
        observaciones: new FormControl('', { nonNullable: true }),
        cantidad: new FormControl('', { nonNullable: true }),
        costo: new FormControl('', { nonNullable: true })
      })
    })
  }

  getEquipoForm () {
    return this.fb.group({
      nombre: new FormControl('', { nonNullable: true }),
      marca: new FormControl('', { nonNullable: true }),
      modelo: new FormControl('', { nonNullable: true }),
      talla: new FormControl('', { nonNullable: true }),
      categoria: new FormControl('', { nonNullable: true }),
      valoracion: new FormControl('', { nonNullable: true }),
      costo: new FormControl('', { nonNullable: true }),
      observaciones: new FormControl('', { nonNullable: true }),
      razonSocial: new FormControl('', { nonNullable: true }),
      ruc: new FormControl('', { nonNullable: true }),
      numFactura: new FormControl('', { nonNullable: true })
    })
  }

  getMenajeriaForm () {
    return this.fb.group({
      nombre: new FormControl('', { nonNullable: true }),
      marca: new FormControl('', { nonNullable: true }),
      modelo: new FormControl('', { nonNullable: true }),
      cantidad: new FormControl('', { nonNullable: true }),
      factura: new FormGroup({
        razonSocial: new FormControl('', { nonNullable: true }),
        ruc: new FormControl('', { nonNullable: true }),
        numFactura: new FormControl('', { nonNullable: true })
      })
    })
  }
}
